const Loader = () => (
    <div className='loader-pre'>
        <div className='loader-status'>&nbsp;</div>
    </div>
);

export default Loader;
